/**
 * RunAI OS — Menu Bar (Apple style)
 * Sol: 🌱 RunAI logo menüsü | Aktif pencere adı + File/Agents/Skills/Cloud/Window/Help
 * Sağ: Agent count | FLZ | Spotlight | Theme | Clock
 * En sağ: User avatar + dropdown
 */
import MenuBarItems from './MenuBarItems'
import MenuBarLogo from './MenuBarLogo'
import MenuBarStatus from './MenuBarStatus'
import { useMenuBarData } from './useMenuBarData'

interface Props {
  onMenuClick?: (item: string) => void
  onSpotlightOpen?: () => void
  onClockClick?: () => void
  onAlertClick?: () => void
  onControlCenterOpen?: () => void
}

export default function MenuBar({ onMenuClick, onSpotlightOpen, onClockClick, onAlertClick, onControlCenterOpen }: Props) {
  const { agentStats, flzBalance } = useMenuBarData()

  return (
    <div style={{
      display: 'flex',
      alignItems: 'center',
      height: 40,
      background: 'var(--os-mb-bg)',
      backdropFilter: 'blur(20px)',
      WebkitBackdropFilter: 'blur(20px)',
      padding: '0 14px',
      fontSize: 12,
      borderBottom: '1px solid var(--os-border)',
      position: 'relative',
      zIndex: 100,
      userSelect: 'none',
      flexShrink: 0,
    }}>
      <MenuBarLogo />
      <MenuBarItems onMenuClick={onMenuClick} />
      <MenuBarStatus
        agentStats={agentStats}
        flzBalance={flzBalance}
        onSpotlightOpen={onSpotlightOpen}
        onClockClick={onClockClick}
        onAlertClick={onAlertClick}
        onControlCenterOpen={onControlCenterOpen}
      />
    </div>
  )
}
